// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"bff3932c","453":"5e6a8551","925":"9a8e4ffa"}[chunkId] + ".chunk.js";
};